// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 这里面文件导入顺序决定样式的覆盖
import Vue from 'vue'
import router from './router'
// import VueI18n from 'vue-i18n'

// Vue.use(VueI18n)
// const i18n = new VueI18n({
//   locale: 'zh', // 语言标识
//   messages: {
//     'zh': require('./assets/lang/zh'),
//     'en': require('./assets/lang/en')
//   }
// })
import ElementUI from 'element-ui'
Vue.use(ElementUI)

import 'element-ui/lib/theme-chalk/index.css'
import './assets/fonts/iconfont.css'

import animated from 'animate.css'
Vue.use(animated)

import Loading from '@/components/loading.js'
Vue.use(Loading)

import App from './App'

// import ECharts from 'vue-echarts/components/ECharts'
// Vue.component('chart', ECharts)

// 引入mqtt
import './mq'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // i18n,
  router,
  components: { App },
  template: '<App/>'
})
// 设置浏览器标题
// Vue.directive('title', {
//   inserted: function (el, binding) {
//     document.title = el.dataset.title
//   }
// })


// WEBPACK FOOTER //
// ./src/main.js